// ダッシュボード
import React, { useState, useEffect, useMemo } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import { Row } from 'react-bootstrap';

interface StatusGroup {
  group_name: string;
  line_number: number;
  status_group_index: string;
  reception: Reception[];
}
interface Reception {
  reception_status_index: string;
  display_name: string;
  all_count: string;
  stay_count: string;
  status: string;
}

// 案件一覧のURL
const reception_list_base_url = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;

const DashboardIndex: React.FC = () => {
  const [is_loading, setIsLoading] = useState(false);
  const [reception_info, setReception] = useState<StatusGroup[]>([]);
  const [error_message, setErrorMessage] = useState();
  const [header_message, setHeaderMessage] = useState('');
  const [news, setNews] = useState([]);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    const getReception = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/staff/dashboard/list_count`);
        setReception(response.data.info);
        setNews(response.data.news);
        setHeaderMessage(response.data.header_message);
      } catch (error) {
        console.error(error.message);
        setErrorMessage(error.response.data.message);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };

    // 案件情報を取得
    getReception();
  }, []);

  // 案件一覧へ戻るボタンのクリックイベントハンドラ
  const handleClick = () => {
    location.replace(reception_list_base_url);
  };

  // 不要なレンダリング防止のためにuseMemoで表示情報を取得する
  const setDisplayInfo = () => {
    const display_info = useMemo(() => createStatusBlockElement(), [reception_info]);
    return display_info;
  };

  // 表示情報生成(ループ処理)
  const createStatusBlockElement = () => {
    return Object.values(reception_info).map((status_group_list: StatusGroup) => {
      // ステータスグループ
      return Object.values(status_group_list).map((status_group: StatusGroup, index: number) => {
        // 行単位
        return Object.values(status_group).map((group: StatusGroup) => {
          // 案件ステータス
          return createElement(group, index);
        });
      });
    });
  };

  // ステータスグループと案件情報のエレメント生成
  const createElement = (group: StatusGroup, index: number) => {
    return (
      // Indexを使用しユニークなkey文字列を生成する
      <div key={`${group.status_group_index}-${index}`} className="box py-3">
        <fieldset className="border border-primary status-width mx-2">
          <legend className="w-auto px-3 ml-3">{group.group_name}</legend>
          {/* 案件情報のエレメント生成 */}
          {createReceptionElement(group.reception)}
        </fieldset>
        <div className="px-5"></div>
      </div>
    );
  };

  // 案件情報のエレメント生成
  const createReceptionElement = (reception: Reception[]) => {
    let reception_list_search_url_all_count: string = reception_list_base_url;
    let reception_list_search_url_stay_count: string = reception_list_base_url;
    let query_string_all_count: string = '';
    let query_string_stay_count: string = '';
    return (
      <div className="py-3">
        <div className="row px-5">
          <div className="col-lg-7 ml-3">状態</div>
          <div className="col-sm-2 ml-3 text-center">案件数</div>
          <div className="col-sm-2 ml-3 text-center">滞留数</div>
        </div>
        {Object.values(reception).map((reception_row: Reception) => {
          // 案件一覧のURLを生成
          // TODO 案件の更新日を検索パラメータにセットする。(お客様に確認中)
          query_string_all_count =
            '?status_from=' + reception_row.status + '&status_to=' + reception_row.status;
          reception_list_search_url_all_count = reception_list_base_url + query_string_all_count;
          query_string_stay_count =
            '?status_from=' +
            reception_row.status +
            '&status_to=' +
            reception_row.status +
            '&is_stay=true';
          reception_list_search_url_stay_count = reception_list_base_url + query_string_stay_count;
          return (
            <React.Fragment key={reception_row.reception_status_index}>
              <div className="pt-2"></div>
              <div className="row px-5">
                <div className="col-lg-7 ml-3">{reception_row.display_name}</div>
                <div className="col-sm-2 ml-3 text-center">
                  <a href={reception_list_search_url_all_count} className={`link-text`}>
                    {reception_row.all_count}
                  </a>
                </div>
                <div className="col-sm-2 ml-3 text-center">
                  <a href={reception_list_search_url_stay_count} className={`link-text`}>
                    {reception_row.stay_count}
                  </a>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  // 表示情報を取得
  const display_info = setDisplayInfo();
  return (
    <React.Fragment key={'reception_01'}>
      <div className="title_block">{header_message}</div>
      <div className="container">
        {typeof error_message === 'undefined' ? (
          // 取得OK
          // 案件ステータス情報
          <React.Fragment key={'reception_02'}>
            <div className="wrap" key={'reception_03'}>
              {display_info}
            </div>
            <div className="py-3">
              <fieldset className="border border-primary notice_hw mx-2 my-3">
                <legend className="w-auto px-3 ml-3">お知らせ</legend>
                <div className="notice px-3 ml-3">
                  {news.map((line: string) => (
                    <div>{line}</div>
                  ))}
                </div>
              </fieldset>
            </div>
          </React.Fragment>
        ) : (
          // 取得NG
          <div className="alert alert-dange" role="alert">
            {error_message}
          </div>
        )}
        {/* 案件一覧へ戻るボタン */}
        <Row className="ml-2">
          <a className="btn-primary btn btn-xl" onClick={handleClick}>
            案件一覧へ戻る
          </a>
        </Row>
        {/* ローディング画面 */}
        <LoadingModal show={is_loading} />
      </div>
    </React.Fragment>
  );
};

if (document.getElementById('dashboard-index')) {
  render(<DashboardIndex />, document.getElementById('dashboard-index'));
}
